/*
 * サブシステム名：マスタ管理
 * 機能名：取引先マスタ一覧
 */

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'
import header from '@/ddv2.library/header'

const DdSearchList = () => import('@/components/DdSearchList')
const DdCodeTextBox = () => import('../../components/DdCodeTextBox.vue')
const DdDropDown = () => import('@/components/DdDropDown')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdTextBox = () => import('../../components/DdTextBox.vue')

export default {
  name: 'MstTorihikisakiList',
  mixins: [flowMixin],
  components: {
    DdSearchList,
    DdCodeTextBox,
    DdDropDown,
    DdRadioButton,
    DdTextBox
  },
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isCsvDownloader: false,
    isPdfDownloader: false,

    conditions: {
      torihikisakiCd: '',
      torihikisakiKbn: '0',
      tokuisakiFlg: true,
      shiiresakiFlg: true,
      hacchusakiFlg: true,
      torihikisakiNm: '',
      torihikisakiNmKana: '',
      shanaiTantoshaCd: '',
      torihikisakiBunruiKbn1: null,
      torihikisakiBunruiKbn2: null,
      torihikisakiBunruiKbn3: null
    },
    headersShanaishuTantoshaList: header.mstJininHeaders,
    modeKengen: 0
  }),
  computed: {
    filteredRows () {
      return this.rows.map((elem) => {
        elem.jusho = (([undefined, null].includes(elem.jusho1) ? '' : elem.jusho1) + ' ' + ([undefined, null].includes(elem.jusho2) ? '' : elem.jusho2) + ' ' + ([undefined, null].includes(elem.jusho3) ? '' : elem.jusho3)).trim()
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        elem.hyojiOrderDisp = elem.hyojiOrder ? filter.numericFormatter(elem.hyojiOrder) : ''
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    },
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      jininList: 'DDMasters/vwCMstEigyoshoJininList',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      shubetsuList: 'DDMasters/mstShubetsu',
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    filteredShanaishuTantoshaList () {
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.jininCd > elem2.jininCd) { return 1 }
        if (elem1.jininCd === elem2.jininCd) { return 0 }
        return -1
      })
    },
    torihikisakiBunruiKbn1List () {
      const list = this.shubetsuList.filter((elem) => elem.sbtShuruiCd === 'SBT002')
        .map((elem) => {
          elem.value = elem.sbtCd.trim()
          elem.text = elem.sbtNm.trim()
          return elem
        })
      list.unshift({ value: null, text: '未選択' })
      return list
    },
    torihikisakiBunruiKbn2List () {
      const list = this.shubetsuList.filter((elem) => elem.sbtShuruiCd === 'SBT003')
        .map((elem) => {
          elem.value = elem.sbtCd.trim()
          elem.text = elem.sbtNm.trim()
          return elem
        })
      list.unshift({ value: null, text: '未選択' })
      return list
    },
    torihikisakiBunruiKbn3List () {
      const list = this.shubetsuList.filter((elem) => elem.sbtShuruiCd === 'SBT004')
        .map((elem) => {
          elem.value = elem.sbtCd.trim()
          elem.text = elem.sbtNm.trim()
          return elem
        })
      list.unshift({ value: null, text: '未選択' })
      return list
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        conditions: this.conditions,
        searchText: this.searchText,
        rows: this.rows
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'vwcmsteigyoshojininlist', 'mstshubetsu', 'msteigyosho'],
        defineHeaderPromise: () => {
          return new Promise((resolve) => {
            console.log('MstToriikisakiList.defineHeaderPromise')
            self.headers = [
              { text: '操作', value: 'actions', sortable: false, width: '20px' },
              { text: '取引先コード', value: 'torihikisakiCd' },
              { text: '荷主', value: 'tokuisaki', align: 'center' },
              { text: '傭車先', value: 'hacchusaki', align: 'center' },
              { text: '仕入先', value: 'shiiresaki', align: 'center' },
              { text: '取引先名称', value: 'torihikisakiNm' },
              { text: '取引先名称カナ', value: 'torihikisakiNmKana' },
              { text: '取引先正式名称', value: 'torihikisakiSeishikiNm' },
              /*
              { text: '取引先略称', value: 'torihikisakiAbbr' },
              { text: '社内主担当者', value: 'shanaiTantoshaNm' },
              { text: '地域種別', value: 'chiikiKubunNm' },
              { text: '地区種別', value: 'chikuKubunNm' },
              { text: '取引先分類種別１', value: 'torihikisakiBunruiKubun1Nm' },
              { text: '取引先分類種別２', value: 'torihikisakiBunruiKubun2Nm' },
              { text: '取引先分類種別３', value: 'torihikisakiBunruiKubun3Nm' },
              */
              { text: '郵便番号', value: 'yubinNo' },
              { text: '住所', value: 'jusho' },
              // { text: '住所２', value: 'jusho2' },
              // { text: '住所３', value: 'jusho3' },
              { text: '電話番号', value: 'telNo' },
              { text: 'FAX番号', value: 'faxNo' },
              { text: 'メールアドレス', value: 'mailAddress' },
              { text: '部署名', value: 'bushoNm' },
              { text: '取引先担当者名', value: 'tantoshaNm' },
              { text: '社内備考', value: 'shanaiBiko' },
              { text: '適用開始年月日', value: 'tekiyoStartYmdDisp', align: 'center' },
              { text: '適用終了年月日', value: 'tekiyoEndYmdDisp', align: 'center' },
              { text: '表示順', value: 'hyojiOrderDisp', align: 'end' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            console.log('initializeInputPromise')
            self.conditions = {
              torihikisakiCd: '',
              torihikisakiKbn: '0',
              tokuisakiFlg: false,
              shiiresakiFlg: false,
              hacchusakiFlg: false,
              torihikisakiNm: '',
              torihikisakiNmKana: '',
              shanaiTantoshaCd: '',
              torihikisakiBunruiKbn1: null,
              torihikisakiBunruiKbn2: null,
              torihikisakiBunruiKbn3: null
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('MstTorihikisakiList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('MstTorihikisakiList.savedInputRestorePromise after loadFromCache', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstTorihikisakiList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstTorihikisakiList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.selected = []
      this.page = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          self.setSelectedKbn()
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCMstTorihikisaki/Search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            torihikisakiKbn: self.conditions.torihikisakiKbn
          }
        }
      }
      this.search(opt)
    },
    setSelectedKbn: function () {
      const kbn = this.conditions.torihikisakiKbn
      this.conditions.tokuisakiFlg = kbn === '1'
      this.conditions.shiiresakiFlg = kbn === '2'
      this.conditions.hacchusakiFlg = kbn === '3'
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      console.log('clear pushed')
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            self.conditions = {
              torihikisakiCd: '',
              torihikisakiKbn: '0',
              tokuisakiFlg: false,
              shiiresakiFlg: false,
              hacchusakiFlg: false,
              torihikisakiNm: '',
              torihikisakiNmKana: '',
              shanaiTantoshaCd: '',
              torihikisakiBunruiKbn1: null,
              torihikisakiBunruiKbn2: null,
              torihikisakiBunruiKbn3: null
            }
            self.searchText = ''
            self.rows = []
            self.selected = []
            self.page = 1
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onCreateButtonClick: function (e) {
      console.log('onCreateButtonClick 0', e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    onTokuisakiCreateButtonClick: function (e) {
      console.log('onCreateButtonClick 1', e)
      this.Effects.loadStart()
      this.transition(1, { id: 0 })
    },
    onHacchusakiCreateButtonClick: function (e) {
      console.log('onCreateButtonClick 2 ', e)
      this.Effects.loadStart()
      this.transition(2, { id: 0 })
    },
    onShiiresakiCreateButtonClick: function (e) {
      console.log('onCreateButtonClick 3', e)
      this.Effects.loadStart()
      this.transition(3, { id: 0 })
    },
    searchValidate: function () {
      return true
    }
  }
}
